// @flow
import React, { useState } from 'react';
import ReactCodeInput from 'react-verification-code-input/dist';
import { useDispatch, useSelector } from 'react-redux';

import Card from '../../components/Card';
import { H2 } from '../../components/Typography';
import styles from './styles.module.scss';
import P from '../../components/Typography/P';
import actionTypes from '../../store/auth/actionTypes';

const ConfirmEmail = () => {
  const dispatch = useDispatch();
  const [code, setCode] = useState<string>('');
  const isLoading = useSelector((state) => state.api.CONFIRM_EMAIL.loading);
  if (code.length === 6) {
    dispatch({ type: actionTypes.CONFIRM_EMAIL, code });
    setCode('');
  }
  return (
    <Card
      use="light"
      className={styles.containerForm}
      title={(
        <>
          <H2 color="dark" className={styles.title}>Verify your email</H2>
          <div className={styles.subtitle}>Please check spam box</div>
        </>
      )}
    >
      <P
        use="dark"
        size="small"
      >
        Please enter verification code send to your email
      </P>
      <ReactCodeInput
        value={code}
        onChange={(e) => setCode(e)}
        loading={isLoading}
      />
    </Card>
  );
};

export default ConfirmEmail;
